import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const NotificationItemFooterStyled = styled.footer.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "notification-item-footer",
  },
)`
  border-top: 1px dashed ${rydeColors.grey};
  padding-top: 8px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
`;
